import { Component } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  public loading: Subject<boolean> = this.loaderService.loading;
  constructor(private loaderService: LoaderService) {}
}
